'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002etime$002eformat$002e$002dSign$002dStyle from "./java.time.format.-Sign-Style.js";
import * as $j_scala$002eruntime$002e$002dEnum$002dValue from "./scala.runtime.-Enum-Value.js";
var $p;
/** @constructor */
function $c_Ljava_time_format_SignStyle$$anon$3() {
  this.q = null;
  this.M = 0;
  this.jV = 0;
  $j_java$002etime$002eformat$002e$002dSign$002dStyle.$ct_Ljava_time_format_SignStyle__T__I__T__I__(this, "NEVER", 2, "NEVER", 2);
}
export { $c_Ljava_time_format_SignStyle$$anon$3 as $c_Ljava_time_format_SignStyle$$anon$3 };
$p = $c_Ljava_time_format_SignStyle$$anon$3.prototype = new $j_java$002etime$002eformat$002e$002dSign$002dStyle.$h_Ljava_time_format_SignStyle();
$p.constructor = $c_Ljava_time_format_SignStyle$$anon$3;
/** @constructor */
function $h_Ljava_time_format_SignStyle$$anon$3() {
}
export { $h_Ljava_time_format_SignStyle$$anon$3 as $h_Ljava_time_format_SignStyle$$anon$3 };
$h_Ljava_time_format_SignStyle$$anon$3.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_format_SignStyle$$anon$3 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_SignStyle$$anon$3, "java.time.format.SignStyle$$anon$3", ({
  ls: 1,
  br: 1,
  n: 1,
  j: 1,
  a: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_format_SignStyle$$anon$3 as $d_Ljava_time_format_SignStyle$$anon$3 };
